export enum MessageComposerType {
  TEXT,
  VOICE,
}
